import { DashboardIcon } from './templates/dashboard-icon/dashboard-icon';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { DashboardGridItem } from './templates/dashboard-grid-item/dashboard-grid-item';
import { DashboardListWidget } from './templates/dashboard-list-widget/dashboard-list-widget';
import { DashboardGrid } from './templates/dashboard-grid/dashboard-grid';
import { DashboardGraphWidget } from './templates/dashboard-graph-widget/dashboard-graph-widget';
import { DashboardNumberWidget } from './templates/dashboard-number-widget/dashboard-number-widget';
import { DashboardPercentageWidget } from './templates/dashboard-percentage-widget/dashboard-percentage-widget';
import { DashboardWelcomeWidget } from './templates/dashboard-welcome-widget/dashboard-welcome-widget';
import { ReportChart } from './templates/report-chart/report-chart';
import { ReportValue } from './templates/report-value/report-value';
import { ReportWidget } from './templates/report-widget/report-widget';
import { DashboardWidgetPreview } from './templates/dashboard-widget-preview/dashboard-widget-preview';
import { DashboardSankeyWidget } from './templates/dashboard-sankey-widget/dashboard-sankey-widget';
import { ReportSpreadsheet } from './templates/report-spreadsheet/report-spreadsheet';
import { DashboardPositionWidget } from './templates/dashboard-position-widget/dashboard-position-widget';
import { DashboardFinanceMoneyWidget } from './templates/dashboard-finance-money-widget/dashboard-finance-money-widget';
import { DashboardRecordMetric } from './templates/dashboard-record-metric/dashboard-record-metric';

@NgModule({
  declarations: [
    DashboardGridItem,
    DashboardListWidget,
    DashboardPositionWidget,
    DashboardFinanceMoneyWidget,
    DashboardGrid,
    DashboardGraphWidget,
    DashboardSankeyWidget,
    DashboardNumberWidget,
    DashboardPercentageWidget,
    DashboardWelcomeWidget,
    ReportChart,
    ReportValue,
    ReportWidget,
    DashboardWidgetPreview,
    ReportSpreadsheet,
    DashboardFinanceMoneyWidget,
    DashboardRecordMetric,
  ],
  imports: [
    DashboardIcon,
    CommonModule,
    FormsModule,
    DragDropModule,
  ],
  exports: [
    DashboardIcon,
    DashboardGridItem,
    DashboardListWidget,
    DashboardPositionWidget,
    DashboardGrid,
    DashboardGraphWidget,
    DashboardSankeyWidget,
    DashboardNumberWidget,
    DashboardPercentageWidget,
    DashboardWelcomeWidget,
    ReportChart,
    ReportValue,
    ReportWidget,
    ReportSpreadsheet,
  ],
})
export class WidgetAndGraphsModule { }
